<template>
  <div class="display_flex_center" style="height: 50px;">
    <!-- 图片 -->
    <div v-if="filetype == 1">
      <img src="../assets/imgicon/wjj.png" alt="" style="width: 50px;height: 50px;">
    </div>
    <div class="look_img"  v-else>
           <div style="width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;"
        v-if="filename(fileNameURl) == 'png' || filename(fileNameURl) == 'jpeg' || filename(fileNameURl) == 'jpg'
          || filename(fileNameURl) == 'JPG' || filename(fileNameURl) == 'gif' || filename(fileNameURl) == 'svg'"
        class="demo-image__preview">
        <img :src="urlfile(fileSmallPath)" @error="setDefaultImage" alt="" v-if="fileSmallPath">
        <img :src="urlfile(fileNameURl)" @error="setDefaultImage" alt="" v-else>
      </div>
      <div v-else-if="filename(fileNameURl) == 'mp4' || filename(fileNameURl) == 'MP4' || filename(fileNameURl) == 'm4v' || filename(fileNameURl) == 'mov'" style="width: 50px;height: 50px;border-radius: 5px;position: relative;">
        <img :src="generatePosterUrl(fileSmallPath)"  @error="setDefaultVideoImage" alt="" style="width: 100%;height: 100%;border-radius: 7px;">
        <div v-if="fileSmallPath" style="position: absolute;top: 0;background: rgba(0, 0, 0, 0.25);color: #fff;padding: 5px;border-radius: 5px;width: 100%;height: 100%;"></div>
        <img v-if="fileSmallPath" :src="video_look" alt="" style="width: 35%;height: 35%;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);">
      </div> 

      <img v-else-if="filename(fileNameURl) == 'pdf' || filename(fileNameURl) == 'text'" src="../assets/imgicon/pdf.png"
        alt="" style="width: 50px;height: 50px;">
      <img v-else-if="filename(fileNameURl) == 'ppt' || filename(fileNameURl) == 'pptx'" src="../assets/imgicon/ppt.png"
        alt="" style="width: 50px;height: 50px;">
      <img v-else-if="filename(fileNameURl) == 'docx' || filename(fileNameURl) == 'txt'"
        src="../assets/imgicon/word.png" alt="" style="width: 50px;height: 50px;">
      <img
        v-else-if="filename(fileNameURl) == 'xlsx' || filename(fileNameURl) == 'xls' || filename(fileNameURl) == 'xmind'"
        src="../assets/imgicon/x.png" alt="" style="width: 50px;height: 50px;">
      <img v-else-if="filename(fileNameURl) == 'zip' || filename(fileNameURl) == 'rar'" src="../assets/imgicon/zip.png"
        alt="" style="width: 50px;height: 50px;">
      <img v-else-if="filename(fileNameURl) == 'ai'" src="../assets/imgicon/ai.png" alt=""
        style="width: 50px;height: 50px;">
      <img v-else-if="filename(fileNameURl) == 'psd'" src="../assets/imgicon/ps.png" alt=""
        style="width: 50px;height: 50px;">
      <img v-else-if="filename(fileNameURl) == 'exe'" src="../assets/imgicon/exe.png" alt=""
        style="width: 50px;height: 50px;">
      <img v-else-if="filename(fileNameURl) == 'html'" src="../assets/imgicon/html.png" alt=""
        style="width: 50px;height: 50px;">
      <img v-else src="../assets/imgicon/wenhao.png" alt="" style="width: 50px;height: 50px;">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    fileNameURl: {
      type: String,
      default: ''
    },
    fileSmallPath: {
      type: String,
      default: ''
    },
    filetype: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      api_loading: require('../assets/img/api_loading.gif'),
      apiVideo_loading: require('../assets/imgicon/video.png'),
      video_look: require('../assets/imgicon/video_look.png'),
    }
  },
  mounted() {

  },
  computed: {

  },
  methods: {
    generatePosterUrl(videoUrl) {
      return this.$lookfile + '/small/' + videoUrl
      // return videoUrl + "?x-oss-process=video/snapshot,t_1,m_fast";
    },
    setDefaultImage(e) {
      e.target.src = this.api_loading
    },
      setDefaultVideoImage(e) {
      e.target.src = this.apiVideo_loading
    },
    urlfile(fileNameURl) {
      return this.$lookfile + '/small/' + fileNameURl
    },
  },
}
</script>
<style lang='less' scoped>
/deep/ .el-image {
  max-width: 100% !important;
  max-height: 100% !important;
}

.demo-image__preview {
  img {
    width: auto;
    height: auto;
    max-width: 100% !important;
    max-height: 100% !important
  }
}

.look_img{
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
